// extracted by mini-css-extract-plugin
export default {"TrucksGrid":"rxLPTWWVVa7NXP1kRAtG","Breadcrumbs":"D7El2fJGVbY5CzQmc2Kw","CrossLinks":"E9PYMldoTID76vQOEBCA","CateringCta":"YuUf7a2jrXZnsjunsM0c"};